export default __webpack_public_path__ + "static/media/fibswap_dex.733718e3.jpeg";